var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareOutlinedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#E83A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6451 16.1669C36.6451 18.1576 35.0313 19.7713 33.0407 19.7713C31.9905 19.7713 31.0452 19.3222 30.3864 18.6055L18.2268 25.6038C18.3319 25.9421 18.3885 26.3017 18.3885 26.6746C18.3885 27.0469 18.3321 27.406 18.2272 27.7439L30.3876 34.7424C31.0463 34.0265 31.9911 33.5779 33.0407 33.5779C35.0313 33.5779 36.6451 35.1916 36.6451 37.1823C36.6451 39.1729 35.0313 40.7867 33.0407 40.7867C31.05 40.7867 29.4362 39.1729 29.4362 37.1823C29.4362 36.8093 29.4929 36.4496 29.5981 36.1112L17.4386 29.1129C16.7798 29.8297 15.8344 30.279 14.7841 30.279C12.7934 30.279 11.1797 28.6653 11.1797 26.6746C11.1797 24.6839 12.7934 23.0702 14.7841 23.0702C15.8339 23.0702 16.7789 23.519 17.4376 24.2352L29.5976 17.2366C29.4927 16.8986 29.4362 16.5394 29.4362 16.1669C29.4362 14.1762 31.05 12.5625 33.0407 12.5625C35.0313 12.5625 36.6451 14.1762 36.6451 16.1669Z",
    fill: "#E83A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOutlinedRed);
export default __webpack_public_path__ + "static/media/share-outlined-red.7b691da6ebda091bfd33e65ccd6d986a.svg";
export { ForwardRef as ReactComponent };